import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Divider as AntDivider } from "antd";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  div:first-child {
    padding-bottom: 8px;
  }
`;

const Title = styled(AntDivider)`
  .ant-divider-inner-text {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.textColor};
    background: ${(props) => props.theme.white};
    border-radius: 21px;
    padding: 4px 16px 4px 16px;
  }

  ::before,
  ::after {
    border: 1px solid ${(props) => props.theme.divider};
    border-color: ${(props) => props.theme.divider} !important;
  }
`;

const LightText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: #000000;
  text-align: left;
`;

const TermsConditions = ({ title, rule }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
      <LightText dangerouslySetInnerHTML={{ __html: rule }} />
    </Box>
  );
};

export default TermsConditions;
